module.exports = __webpack_public_path__ + "static/media/three_dot_circle.7c1bba11.svg";